// Source identifiers emitted by the production-facing Stage 1 collectors.
// Legacy seed/demo labels (for example GITHUB or FUNDING_DATABASE) are
// intentionally excluded from the console so they cannot affect live scores.
export const COLLECTOR_SOURCES = [
  { id: 'github', label: 'GitHub' },
  { id: 'huggingface', label: 'Hugging Face' },
  { id: 'JOB_BOARD', label: 'Job Boards' },
  { id: 'sec_edgar', label: 'SEC EDGAR' },
  { id: 'arxiv', label: 'arXiv' },
];

export const COLLECTOR_SOURCE_IDS = COLLECTOR_SOURCES.map(({ id }) => id);

const SOURCE_LABELS = new Map(
  COLLECTOR_SOURCES.map(({ id, label }) => [id, label])
);

export function sourceLabel(source) {
  return SOURCE_LABELS.get(source) || source;
}

export function collectorSourceOptions(counts = {}) {
  return COLLECTOR_SOURCES
    .map(({ id, label }) => ({ source: id, label, count: counts[id] || 0 }));
}
